module.exports = function addressToPlace(address) {
	if(!address)
		return '';
	return `${address.street} ${address.streetNumber}, ${address.postalCode} ${address.city}`.trim();
};